// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPopup_container__1vFUu","selector":"OrderPopup_selector__28UDM","actionContainer":"OrderPopup_actionContainer__3XM4k"};